module.exports = __webpack_public_path__ + "static/media/scene_creator_onboarding_2.19ce7f78.jpg";